import React from 'react';
import styles from './close.module.sass';
import applyWrappers from 'wrappers/ComponentWrapper';

const Close = (props) => {

	const strokeWidth = props.strokeWidth ? props.strokeWidth : "2";

	const strokeColor = '#000000';
	return (
		<div styleName="main-component">
			<svg width="100%" height="100%" viewBox="0 0 17 18" fill="none">
				<path d="M15.5 1L8.25 8.67647M1 16.3529L8.25 8.67647M8.25 8.67647L1 1L15.5 16.3529" stroke={strokeColor} strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" />
			</svg>
		</div>
	);
}

export default applyWrappers(Close, styles);